export class PageProgressionParser {
    /** @inheritdoc */
    parseValue(rawValue) {
        if (typeof rawValue !== 'string')
            return undefined;
        return rawValue;
    }
}
// use a shared static instance for performance instead of
// instantiating a new instance for every use
PageProgressionParser.shared = new PageProgressionParser();
//# sourceMappingURL=page-progression.js.map